import { gql } from 'graphql-request'
import { GenericBlock } from './generic'
import { ExcludedPlatforms } from 'app/types/excludedPlatforms'

export const trendingSeriesFragment = gql`
  fragment trendingSeriesFragment on TrendingSeries {
    id
    title
    collections {
      name
      subtitle
      slug
      thumbnail {
        id
        sizes {
          square {
            url
          }
        }
      }
      itemCount
    }
    excludedPlatforms {
      ios
      android
      web
    }
  }
`

export interface TrendingSeries extends GenericBlock<'TrendingSeries'> {
  title: string
  collections: any[]
  excludedPlatforms: ExcludedPlatforms
}
